import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "./i18n/LanguageContext";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Advantage } from "./components/Advantage";
import { ServiceAreas } from "./components/ServiceAreas";
import { RecentWork } from "./components/RecentWork";
import { Testimonials } from "./components/Testimonials";
import { QuoteForm } from "./components/QuoteForm";
import { Footer } from "./components/Footer";
import { FloatingCall } from "./components/FloatingCall";

const Landing = () => (
  <div className="font-body bg-ink text-white selection:bg-heat/40">
    <Header />
    <main data-testid="main-landing">
      <Hero />
      <Services />
      <Advantage />
      <ServiceAreas />
      <RecentWork />
      <Testimonials />
      <QuoteForm />
    </main>
    <Footer />
    <FloatingCall />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          richColors
          toastOptions={{
            style: { background: "#111C3D", color: "#fff", border: "1px solid rgba(255,255,255,0.1)" },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
